import React from 'react';
import Title from '../../../../components/forms/titles.component';
import Button from '../../../../components/forms/button.component';
import Icon from '../../../../components/forms/icon.component';
import EdgeKeywordsForm from '../../../../components/nodes/form/edge-keywords.component';

interface EdgeSidePanelProps {
  selectedEdge: any;
  onDeleteEdge: (edgeId: string) => void;
  onAddEdgeKeyword: (edgeId: string, keyword: string) => void;
  onRemoveEdgeKeyword: (edgeId: string, keyword: string) => void;
}

const EdgeSidePanel: React.FC<EdgeSidePanelProps> = ({
  selectedEdge,
  onDeleteEdge,
  onAddEdgeKeyword,
  onRemoveEdgeKeyword
}) => {
  const keywords = selectedEdge.data?.keywords ?? ([] as string[]);
  return (
    <div className="shadow-sm node-side-panel p-4" style={{ minHeight: 'auto' }}>
      <div className="d-flex flex-column">
        <div className="flex-grow-1 p-6">
          <Title
            icon="ki-right-left"
            title="Conexión entre nodos"
            subtitle="Configura la relación entre dos nodos"
            type="info"
          />
          <div className="separator mt-4 mb-6" />
          <div className="d-flex align-items-center my-5">
            <Icon icon="ki-exit-right" size="fs-2x" className="me-2" />
            <strong>Origen:</strong> {selectedEdge.source}
          </div>
          <div className="d-flex align-items-center my-5">
            <Icon icon="ki-entrance-left" size="fs-2x" className="me-2" />
            <strong>Destino:</strong> {selectedEdge.target}
          </div>
          {keywords.length > 0 && (
            <EdgeKeywordsForm
              edge={selectedEdge}
              onAddEdgeKeyword={onAddEdgeKeyword}
              onRemoveEdgeKeyword={onRemoveEdgeKeyword}
            />
          )}
          <div className="border-top pt-5 mt-7 w-100">
            <Button className="btn btn-danger w-100" onClick={() => onDeleteEdge(selectedEdge.id)}>
              <Icon icon="ki-trash" size="fs-2" />
              Eliminar conexión
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EdgeSidePanel;
